'use client';

import { c } from '../../../utils/tailwind-merge';
import { ViewModeToggle } from '../../atoms/ViewModeToggle';
import { AccountListTabs } from '../AccountListTabs';
import type { AccountListTabsBarProps } from './AccountListTabsBar.types';

export const AccountListTabsBar = ({
  organization,
  viewMode,
  microcopy,
  onViewModeChange,
  className = '',
}: AccountListTabsBarProps) => {
  return (
    <div
      className={c(
        organization
          ? 'flex justify-between md:items-center lg:items-end'
          : 'hidden justify-end md:flex',
        className
      )}
    >
      {organization && microcopy.tabs && (
        <AccountListTabs
          userName={organization.userName}
          userProfilePicture={organization.userProfilePicture}
          publisherName={organization.publisherName}
          personalCount={organization.personalCount}
          organizationCount={organization.organizationCount}
          value={organization.activeTab}
          personalSectionId={organization.personalSectionId}
          organizationSectionId={organization.organizationSectionId}
          microcopy={microcopy.tabs}
          onValueChange={organization.onTabChange}
        />
      )}
      <ViewModeToggle
        value={viewMode}
        microcopy={microcopy.viewMode}
        onValueChange={onViewModeChange}
        className="hidden md:inline-flex"
      />
    </div>
  );
};

AccountListTabsBar.displayName = 'AccountListTabsBar';
